export default [{
  path: '/staff/current',
  name: 'current',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/staff/current')
}]
